import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RestorePassword} from '../components/restore-password/restore-password';

@Injectable()
export class RestorePasswordService {

  constructor(private http: HttpClient) {
  }

  restorePassword(email: string) {
    return this.http.get('api/s/restore-password/byEmail/' + email);
  }

  getHashData(hashId: string) {
    return this.http.get('api/s/restore-password/getHashData/' + hashId);
  }

  changePassword(changed: RestorePassword) {
    return this.http.post<any>('api/s/restore-password/change', changed);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/restore-password.service.ts